module.exports = __webpack_public_path__ + "img/linkedin-icon-wit.7fdcda0461df2e544035a19982759d77.svg";